import { createReducer } from "reduxsauce"
import { get, omit } from "lodash"
import actionCreator from "helpers/actionCreator"
import { takeLatest, select, put } from "redux-saga/effects"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { Types as HistoryTypes } from "../../../actions/app/history"
import { getCategoryItemsSubset } from "modules/analyze-composition/selectors/data"
import { DESC, orderState, handleSort } from "helpers/sorts"

export const { Types, Creators } = actionCreator("ompnt/modules/securityProfileComposition", {
  toggle: {
    props: ["id", "currentState"],
    track: true,
    trackType: "security-profile-beta-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setDisplayType: {
    props: ["displayType"],
    track: true,
    trackType: "security-profile-beta-category-selection",
    trackPayload: ({ displayType }) => ({ type: displayType }),
  },
  sort: {
    props: ["order"],
    track: true,
    trackType: "security-profile-concentration-contributors-sorting",
    trackPayload: ({ order }) => order,
  },
  toggleOnly: {
    props: ["id", "state"],
    track: true,
    trackType: "security-profile-beta-graph-legend-factor",
    trackPayload: ({ id, state }) => ({ factor: id, state }),
  },
  toggleOnlySuccess: ["selected", "only", "items"],
})

const defaultOrder = orderState("economicExposure", DESC)

const DEFAULT_STATE = {
  displayType: "beta",
  order: defaultOrder,
  focusedChartLine: null,
  disabled: {},
  only: null,
}

function handleSetDisplayType(state, { displayType }) {
  return {
    ...state,
    displayType,
    only: null,
  }
}

function handleToggle(state, { id }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id
    disabled = omit(state.disabled, id)
  } else {
    focusedChartLine = null
    disabled = { [id]: true, ...state.disabled }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleNavigate(state, action) {
  if (get(action, "location.query.security", null)) {
    return { ...state, displayType: "beta", focusedChartLine: null }
  } else {
    return state
  }
}

function handleToggleOnlySuccess(state, { selected, only, items }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected
    items.forEach(item => {
      if (item.id !== selected) {
        disabled[item.id] = true
      }
    })
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SORT]: handleSort,
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [HistoryTypes.NAVIGATE]: handleNavigate,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
})

function* handleToggleOnly({ id }) {
  const { items, only } = yield select(state => ({
    items: getCategoryItemsSubset(state),
    only: state.modules.securityProfileComposition.only,
  }))

  yield put(Creators.toggleOnlySuccess(id, only !== id, items))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
